import React, { useContext } from "react";

import SubNavbar from "./components/SubNavbar";
import Navbar from "./components/Navbar";
import Banner from "./Home/Banner";
import Featured from "./Home/Featured";
import VideoSection from "./Home/VideoSection";
import VideoContent from "./Home/VideoContent";
import Fun from "./Home/Fun";
import Section from "./Home/Section";
import Properties from "./Home/Properties";
import Contact from "./Home/Contact";
import End from "./Home/End";
import Footer from "./Home/Footer";
import { CartProvider } from "react-use-cart";



function App() {
  return (
    <CartProvider>
      <SubNavbar/>
      <Navbar/>
      <Banner/>
      <Featured/>
      <VideoSection/>
      <VideoContent/>
      <Fun/>
      <Section/>
      <Properties/>
      <Contact/>
      <End/>
      <Footer/>
      
    </CartProvider>
  );
}

export default App;
